import { ThemeProvider, Global } from "@emotion/react";
import { observer } from "mobx-react-lite";
import { useSingleton } from "../../other/injection";
import { global } from "./global";
import { ThemeStore } from ".";
import { ReactNode } from "react";

const Provider = observer(({ children }: { children: ReactNode }) => {
    const themeStore = useSingleton(ThemeStore);
    return (
        <>
            {/* ThemeProvider should only contain props.children to avoid unneccessary re-renders */}
            <ThemeProvider theme={themeStore.theme}>{children}</ThemeProvider>
        </>
    );
});

export const RootProvider = ({ children }: { children: ReactNode }) => {
    return (
        <Provider>
            <Global styles={global} />
            {children}
        </Provider>
    );
};
